export const classes = {
  frame: 'relative w-full overflow-hidden',
  layer: 'absolute inset-0',
  chart: 'absolute inset-0',
  hidden: 'invisible',
};

export const styles = {
  frame: (height?: number) => (height ? { height: `${height}px` } : {}),
};
